import * as React from "react";
import { Notification, NotificationLineItem } from "@interfaces/notification";
import { deleteBatchApiData, listApiData } from "@hooks/utils/api";
import { decodeNotification, encodeNotification } from "decoders/notification";

export const useNotifications = (userId?: string) => {
  const [notifications, setNotifications] = React.useState<
    NotificationLineItem[]
  >([]);
  const [isNotificationsLoading, setIsNotificationsLoading] =
    React.useState<boolean>(false);
  const [error, setError] = React.useState<string | null>(null);

  const listNotifications = async (userId: string): Promise<void> => {
    try {
      setIsNotificationsLoading(true);
      const notificationResult = await listApiData(
        "listNotifications",
        "notifications",
        userId
      );
      setNotifications(
        notificationResult.data.map((p) =>
          decodeNotification(p as Notification)
        )
      );
    } catch (e: any) {
      setError("Could not list notifications");
    } finally {
      setIsNotificationsLoading(false);
    }
  };

  const deleteNotifications = async (
    notificationsToDelete: NotificationLineItem[]
  ): Promise<void> => {
    try {
      setIsNotificationsLoading(true);
      const encodedNotifications = notificationsToDelete.map((e) =>
        encodeNotification(e)
      );
      await deleteBatchApiData(
        "deleteNotifications",
        "notification",
        encodedNotifications
      );

      const deletedRowIds = notificationsToDelete.map((e) => e.id);
      setNotifications(
        notifications.filter((e) => {
          return !deletedRowIds.includes(e.id);
        })
      );
    } catch (e: any) {
      setError("Could not delete notification");
    } finally {
      setIsNotificationsLoading(false);
    }
  };

  React.useEffect(() => {
    if (userId) {
      listNotifications(userId);
    }
  }, [userId]);

  return {
    notifications,
    deleteNotifications,
    isNotificationsLoading,
    error,
  };
};
